import Styles from './styles'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'

const fontSettings = {
  iconfont: ['md', 'fa'],
}

const options = {
  customProperties: true,
}

const vuetifySettings = {}
Object.assign(vuetifySettings, fontSettings)
Object.assign(vuetifySettings, Styles)
Object.assign(vuetifySettings, { options })

export default vuetifySettings
